export default "__VITE_ASSET__DjVSEV2R__"